import React, { lazy, Suspense } from 'react'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { UpdateAccountBalance } from '@core/State/UserAccount/userAccountDriver'
import { trackOptimoveWithdrawalPercentage } from '@core/Services/Optimove/trackOptimoveWithdrawalPercentage'
import { fullClientVersion } from '@core/Utils/clientVersion'
import { useAuthenticatedAccount } from '@core/Components/RequireAuth/hooks'

const App = lazy(() => import('@mobi/account/Areas/Withdraw/Components/App'))

export const Withdraw = (): JSX.Element | null => {
  const { accountNumber } = useAuthenticatedAccount()

  return (
    <Suspense fallback={<Spinner />}>
      <App
        betAccountNumber={accountNumber}
        onWithdrawSuccess={withdrawResponse => {
          trackOptimoveWithdrawalPercentage(withdrawResponse)
          UpdateAccountBalance({ balance: withdrawResponse.balance })
        }}
        appVersion={fullClientVersion}
      />
    </Suspense>
  )
}
